import ajax from './ajaxActions';
import localStorageService from './localStorage';

async function persistAuthSession(data) {
  const token = data?.authToken?.token;
  if (!token) {
    throw new Error('Authentication succeeded but no token was returned.');
  }

  localStorageService.setToken(token);

  let user = data.user;
  if (!isGirderUser(user)) {
    user = await ajax.getUserInfo();
  }
  if (!isGirderUser(user)) {
    localStorageService.deleteUserInfo();
    throw new Error('Authentication succeeded but could not load your DSA user profile.');
  }

  localStorageService.setUserInfo(user);
  return user;
}

function isGirderUser(user) {
  return Boolean(user && (user._id || user.login));
}

async function login({ username = '', password = '' }) {
  const data = await ajax.login({ username, password });
  return persistAuthSession(data);
}

async function loginWithApiKey({ apiKey = '' }) {
  const data = await ajax.loginWithApiKey({ apiKey });
  return persistAuthSession(data);
}

async function logout() {
  try {
    await ajax.logout();
  } catch (error) {
    console.warn('Logout request failed:', error);
  } finally {
    localStorageService.deleteUserInfo();
  }
}

async function validateSession() {
  const data = await ajax.getUserInfo();
  localStorageService.setUserInfo(data);
  return data;
}

function getUserInfo() {
  return localStorageService.getUserInfo();
}

function getToken() {
  return localStorageService.getToken();
}

function isLoggedIn() {
  return !!getToken() && !!getUserInfo();
}

const authService = {
  login,
  loginWithApiKey,
  logout,
  validateSession,
  getToken,
  getUserInfo,
  isLoggedIn,
};

export default authService;
